//handles a click on the partner central logout button
document.getElementById("partner-central-logout")?.addEventListener("click", (event) => {
    const target = event.target;
    const modelUrl = target?.dataset.modelUrl || window.location.href.replace("partnercentral", "partner-central");
    document.cookie = `partnerCentralLogoutUrl=${encodeURIComponent(modelUrl)}; path=/;`;
    location.href = "/system/sling/logout.html?tstamp=" + new Date().getTime();
});
